import { render, staticRenderFns } from "./PickupItem.vue?vue&type=template&id=4d432fd9&scoped=true"
import script from "./PickupItem.vue?vue&type=script&lang=ts"
export * from "./PickupItem.vue?vue&type=script&lang=ts"
import style0 from "./PickupItem.vue?vue&type=style&index=0&id=4d432fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d432fd9",
  null
  
)

export default component.exports